import styled from 'styled-components';
const CampaignEquityStyled = styled.div`
  margin-top:24px;
  .coupon {
    font-size: 14px;
    color: #000;
  }
  
  .MuiFormControlLabel-label {
    font-size: 14px;
    color: #000;
  }
  .desc {
    margin-top: 16px;
    color: #c9c9c9;
    font-size: 14px;
  }
  .MuiFormControlLabel-root {
    height: 14px;
  }
  .table{
    /* width:720px; */
    font-size: 14px;
    font-family: SourceHanSansCN;
    font-weight: 400;
    color: #000000;
    .table-title{
      background: #F6F6F6;
      border-radius: 4px;
      display:flex;
      height:48px;
      display:flex;
      gap:72px;
      align-items:center;
      >div{
        text-align:center;
        &:last-child{
          width: 120px;
          color:#1565C0
        }
      }
      >div:nth-child(1) {
        width: 100px;
        text-align: center;
      }
      >div:nth-child(2) {
        width: 157px;
        text-align: left;
      }
      >div:nth-child(3) {
        flex: 1;
        text-align: left;
      }
      >div:nth-child(4) {
        width: 100px;
        text-align: right;
      }
      div:nth-child(5) {
        width: 180px;
        text-align: right;
      }
    }
  }
  .table-content{
    /* padding-left:42px; */
    .table-row{
      min-height:48px;
      display:flex;
      gap:72px;
      border-bottom:1px solid  #DDDDDD;
      /* justify-content:space-between; */
      align-items:center;
      .subTitle{
        min-width:130px;
      }
      .delete{
        display:flex;
        justify-content:center;
      }
      .coupon {
      fill: #1565c0;
    }
    .noCoupon {
      fill: #c9c9c9;
    }
    .coupon-num {
      color: #1565c0;
    }
    .noCoupon-num {
      color: #c9c9c9;
    }
    .action{
      .MuiTextField-root{
       height:28px;
      }
      display:flex;
      align-items:center;
      .hXAOkb{
        height:18px;
      }
    }
    .edit{
      width: 40px;
      height: 28px;
      /* background: #666464; */
      background: #1565C0;
      color:white;
      border-radius: 4px;
      font-size: 14px;
      font-family: SourceHanSansCN;
      display:flex;
      justify-content:center;
      align-items:center;
      font-weight: 400;
      cursor: pointer;
      margin-left: ${(props) => props.theme.spacing(6 / 8)};
    }
      >div{
        text-align:center;
        &:last-child{
          width: 120px;
          flex: inherit;
        }
      }
      >div:nth-child(1) {
        width: 100px;
        text-align: center;
      }
      >div:nth-child(2) {
        width: 157px;
        text-align: left;
      }
      >div:nth-child(3) {
        flex: 1;
        text-align: left;
      }
      >div:nth-child(4) {
        width: 100px;
        text-align: right;
      }
      >div:nth-child(5) {
        width: 180px;
        display: flex;
        justify-content: flex-end;
        align-items: flex-end;
      }
    }
     
  }
  .level-title-wrap {
    width: 720px;
    height: 48px;
    line-height: 48px;
    font-size: 14px;
    font-family: SourceHanSansCN;
    font-weight: 400;
    color: #000000;
    background: #f6f6f6;
    border-radius: 4px;
    padding: 0 42px;
    div:last-of-type {
      color: #1565c0;
    }
  }
  .level-content {
    width: 720px;
    border: 1px solid red;
    height: 48px;
    line-height: 48px;
    border-bottom: lpx solid #dddddd;
    font-size: 14px;
    font-family: SourceHanSansCN;
    font-weight: 400;
    color: #000000;
    }

    .MuiOutlinedInput-root {
      height: 24px !important;
      margin-right: 0 !important;
      margin: auto;
    }
    .MuiInputBase-input {
      width: 60px;
      text-align: center !important;
    }
    .basic-name {
      /* width: 60px; */
      /* height: 24px !important; */
      background: #ffffff;
      margin-right: 0 !important;
      margin: auto;
      /* border: 2px solid #C9C9C9; */
    }
  }
`;
export default CampaignEquityStyled;
